/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
let flickPatch = {};
class FlickPatch {  //  Flick Carousel ARIA-HIDDEN observer
  constructor(document, selector) {
  this.document = document; 
  this.selector = selector;
  this.sliders = [];
}
init() {
    this.sliders = Array.from( this.document.querySelectorAll( this.selector ))
    if( this.sliders.length){
        this.sliders[0].children.forEach((slider) => {
            const mutationObserver = new MutationObserver(() => {
                if(flickPatch && typeof flickPatch.removeAttr === "function") {
                    flickPatch.removeAttr(slider);
                }
            });
            mutationObserver.observe(slider, { attributes: true, childList: true, subtree: true });
            this.removeAttr(slider);
        })            
    }
    return this;
}
removeAttr(slider) {
    const threshold = 0.1;
    if(slider) {  
        var rect = slider.getBoundingClientRect();
        const overlap = rect.width * threshold;
        var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
        if (!(rect.right < 0 + overlap || rect.left >= viewWidth - overlap)) {
            if(slider.getAttribute("aria-hidden")) {
                slider.removeAttribute("aria-hidden")
            }
        } else {
            if(!slider.getAttribute("aria-hidden")) {
                slider.setAttribute("aria-hidden", "true")
            }
        }
    }
  }
}

window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));
    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }
    
    if(this.collection_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "center",
      wrapAround: true
    }

    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on( 'settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize')
          });
        }
      }
    });

    flickPatch = new FlickPatch( document, ".flickity-slider" );
    flickPatch.init();
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })();